import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getInstitutionColleagues() {
  return fetchQuery("GetInstitutionColleagues", {});
}
